'use strict';
module.exports = [
  '$rootScope',
  '$scope',
  '$q',
  '$state',
  '$stateParams',
  '$uibModal',
  'situationRecordService',
  'datex2EnumsService',
  'sourceService',
  'translateFilter',
  'situationRecordClass',
  'toastService',
  'zonedDateTimeToDateFilter',
  'datex2EnumsTranscodeFilter',
  'clazzNodeFilter',
  'clazzIconFilter',
  'errorHandlerService',
  'FileUploader',
  'base64DownloadFactory',
  'fileExtensionFilter',
  'fileNameFilter',
  'situationRecordTemplateService',
  'keywordsService',
  'channelsService',
  function (
    $rootScope,
    $scope,
    $q,
    $state,
    $stateParams,
    $uibModal,
    situationRecordService,
    datex2EnumsService,
    sourceService,
    translateFilter,
    situationRecordClass,
    toastService,
    zonedDateTimeToDateFilter,
    datex2EnumsTranscodeFilter,
    clazzNodeFilter,
    clazzIconFilter,
    errorHandlerService,
    FileUploader,
    base64DownloadFactory,
    fileExtensionFilter,
    fileNameFilter,
    situationRecordTemplateService,
    keywordsService,
    channelsService
  ) {
    //var mainConfig = global.ngDroAstralSituationRecordMainConfig;

    $scope.markers = [];
    $scope.directions = {};
    $scope.shapes = [];

    $scope.mapLayers = [];

    $scope.showMapLayer = {
      layerCotral: false,
      layerAtac: false,
      layerFerrovieStato: false,
      layerAeroporti1: false,
      layerAeroporti2: false,
      layerPorti1: false,
      layerPorti2: false,
      layerPorti3: false,
      layerTraffico: true,
      layerTransit: false,
      layerMeteo: false,
      layerTelecamereAstral: false,
      layerTelecamereAutostrade: false,
    };

    $scope.myMap = {
      mapId: 'mapMng',
      zoom: 11,
      centerLat: 41.89,
      centerLng: 12.5,
      showDrawing: true,
      enablePath: true,
      enableMarkerDraw: true,
      parentObjEditable: true,
      mapDivStyle: { height: '800px' },
      mapStyle: {
        height: '500px',
        width: '100%',
        position: 'relative',
        display: 'block',
      },
    };

    /**
     * JSON contente la gerarchia di classi che implementa il Situation Record
     */
    $scope.situationRecordTypesTree = undefined;
    /**
     * Enumerazioni Datex2
     */
    $scope.datex2Enums = undefined;

    $scope.situationRecordTypes = situationRecordClass.getSituationRecordTypes();
    /**
     * Sources
     */
    $scope.situationRecordSources = undefined;
    /**
     * Tipo situation record corrente
     */
    $scope.curSituationRecordType = undefined;

    /**
     * Tipo situation record corrente (Tutto il path di derivazione)
     */

    $scope.curSituationRecordTypeList = [];

    /**
     * Nuovi validity periods.
     * Li gestisco a parte altrimenti il filtro orderBy ti sposta le righe mentre stai inserendo se inserisci un validity period antecedente a uno già esistente
     */
    $scope.newValidityPeriods = [];

    /**
     * Copia dei periodi di valoidità originari
     */
    var existingValidityPeriods = [];

    /**
     * situation record corrente
     */
    $scope.curSituationRecord = situationRecordClass.reset();

    /**
     * id del SR in modifica. Nota: lo salvo subito in una variabile per visualizzare correttamente la pagina
     */
    $scope.curSituationRecordId = undefined;

    $scope.menuStatus = {
      isCollapsed: true,
    };

    // $scope.$on('addRegionAndProvince', function (event, data) {
    //   // if (!$scope.curSituationRecord.province) {
    //   var regionAndProvince = findRegionAndProvinceByProvinceShortName(
    //     data.province.shortName,
    //     $scope.regionList,
    //     $scope.provinceList
    //   );

    //   if (regionAndProvince && regionAndProvince.length === 2) {
    //     if (
    //       !$scope.curSituationRecord.province ||
    //       ($scope.curSituationRecord.province &&
    //         $scope.curSituationRecord.province.shortName !== regionAndProvince[1].shortName)
    //     ) {
    //       toastService.createInfoToast('Provincia: ' + regionAndProvince[1].longName);
    //     }
    //   } else {
    //     toastService.createInfoToast('Provincia: ' + 'Altra provincia');
    //   }

    //   $scope.curSituationRecord.region = data.region;
    //   $scope.curSituationRecord.province = data.province;
    //   // }
    // });

    // $scope.$on('removeRegionAndProvince', function (event, data) {
    //   $scope.curSituationRecord.region = undefined;
    //   $scope.curSituationRecord.province = undefined;
    // });

    $scope.$watch('curSituationRecord.province', function (newValue, oldValue) {
      if (newValue) {
        var regionAndProvince = findRegionAndProvinceByProvinceShortName(
          newValue.shortName,
          $scope.regionList,
          $scope.provinceList
        );

        if (regionAndProvince && regionAndProvince.length === 2) {
          $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
            return region.shortName === regionAndProvince[0].shortName;
          });
        } else {
          $scope.curSituationRecord.region = undefined;
        }
      }
    });

    $scope.regionList = [
      {
        shortName: 'Lazio',
        longName: 'Lazio',
      },
      {
        shortName: 'Toscana',
        longName: 'Toscana',
      },
      {
        shortName: 'Umbria',
        longName: 'Umbria',
      },
      {
        shortName: 'Marche',
        longName: 'Marche',
      },
      {
        shortName: 'Abruzzo',
        longName: 'Abruzzo',
      },
      {
        shortName: 'Molise',
        longName: 'Molise',
      },
      {
        shortName: 'Campania',
        longName: 'Campania',
      },
      {
        shortName: 'ALTRO',
        longName: 'ALTRO',
      },
    ];

    $scope.provinceList = [
      {
        name: 'Lazio',
        provinces: [
          { shortName: 'RM', longName: 'Roma' },
          { shortName: 'LT', longName: 'Latina' },
          { shortName: 'FR', longName: 'Frosinone' },
          { shortName: 'RI', longName: 'Rieti' },
          { shortName: 'VT', longName: 'Viterbo' },
        ],
      },
      {
        name: 'Toscana',
        provinces: [
          { shortName: 'GR', longName: 'Grosseto' },
          { shortName: 'SI', longName: 'Siena' },
        ],
      },
      {
        name: 'Umbria',
        provinces: [{ shortName: 'TR', longName: 'Terni' }],
      },
      {
        name: 'Marche',
        provinces: [{ shortName: 'AP', longName: 'Ascoli Piceno' }],
      },
      {
        name: 'Abruzzo',
        provinces: [
          { shortName: 'AQ', longName: "L'Aquila" },
          { shortName: 'TE', longName: 'Teramo' },
        ],
      },
      {
        name: 'Molise',
        provinces: [{ shortName: 'IS', longName: 'Isernia' }],
      },
      {
        name: 'Campania',
        provinces: [{ shortName: 'CE', longName: 'Caserta' }],
      },
      {
        name: 'ALTRO',
        provinces: [{ shortName: 'ALTRO', longName: 'ALTRO' }],
      },
    ];

    $scope.keywordList = [];

    keywordsService.findAll(function (keywords) {
      $scope.keywordList = keywords;
    });

    $scope.checkIfKeywordIsPresent = function (keyword) {
      if ($scope.curSituationRecord.keywords) {
        for (var i = 0; i < $scope.curSituationRecord.keywords.length; i++) {
          if ($scope.curSituationRecord.keywords[i].id == keyword.id) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.addOrRemoveKeyword = function (keyword) {
      if ($scope.curSituationRecord.keywords) {
        for (var i = 0; i < $scope.curSituationRecord.keywords.length; i++) {
          if ($scope.curSituationRecord.keywords[i].id == keyword.id) {
            $scope.curSituationRecord.keywords.splice(i, 1);
            return;
          }
        }
      }

      if (!$scope.curSituationRecord.keywords) {
        $scope.curSituationRecord.keywords = [];
      }

      $scope.curSituationRecord.keywords.push(keyword);
    };

    $scope.channelList = [];

    channelsService.findAll(function (channels) {
      $scope.channelList = channels;
    });

    $scope.checkIfChannelIsPresent = function (channel) {
      if ($scope.curSituationRecord.channels) {
        for (var i = 0; i < $scope.curSituationRecord.channels.length; i++) {
          if ($scope.curSituationRecord.channels[i].id == channel.id) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.addOrRemoveChannel = function (channel) {
      if ($scope.curSituationRecord.channels) {
        for (var i = 0; i < $scope.curSituationRecord.channels.length; i++) {
          if ($scope.curSituationRecord.channels[i].id == channel.id) {
            $scope.curSituationRecord.channels.splice(i, 1);
            return;
          }
        }
      }

      if (!$scope.curSituationRecord.channels) {
        $scope.curSituationRecord.channels = [];
      }

      $scope.curSituationRecord.channels.push(channel);
    };

    /**
     * Aggiunge un nuovo validity period
     * @return {undefined}
     */
    $scope.addNewValidityPeriod = function () {
      //                    if (!$scope.curSituationRecord.validityPeriods)
      //                        $scope.curSituationRecord.validityPeriods = [];
      //                    var d = new Date();
      //
      //                    var newPeriod = {
      //                        dateStart: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
      //                        dateEnd: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 0, 0)
      //                    };
      //
      //                    $scope.curSituationRecord.validityPeriods.push(newPeriod);

      var d = new Date();

      var newPeriod = {
        dateStart: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0),
        dateEnd: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 0, 0),
      };

      $scope.newValidityPeriods.push(newPeriod);
    };

    /**
     * Cancella un nuovo validity period
     * @param {type} period
     * @return {undefined}
     */
    $scope.delNewValidityPeriod = function (period) {
      if (!$scope.newValidityPeriods) $scope.newValidityPeriods = [];
      var index = $scope.newValidityPeriods.indexOf(period);
      if (index > -1) {
        $scope.newValidityPeriods.splice(index, 1);
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': period'
        );
      }
    };

    /**
     * Cancella un Validity period esistente sul situation record
     * @param {type} period
     * @return {undefined}
     */
    $scope.delValidityPeriod = function (period) {
      if (!$scope.curSituationRecord.validityPeriods)
        $scope.curSituationRecord.validityPeriods = [];
      var index = $scope.curSituationRecord.validityPeriods.indexOf(period);
      if (index > -1) {
        $scope.curSituationRecord.validityPeriods.splice(index, 1);
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': period'
        );
      }
    };

    //                /**
    //                 * Cancella un Validity period
    //                 * @param {type} period
    //                 * @return {undefined}
    //                 */
    //                $scope.delValidityPeriod = function (period) {
    //                    if (!$scope.curSituationRecord.validityPeriods)
    //                        $scope.curSituationRecord.validityPeriods = [];
    //                    var index = $scope.curSituationRecord.validityPeriods.indexOf(period);
    //                    if (index > -1) {
    //                        $scope.curSituationRecord.validityPeriods.splice(index, 1);
    //
    //                    } else {
    //                        toastService.createErrorToast(translateFilter('AstralSituationRecord.notValidParameter') + ': period');
    //                    }
    //
    //                };

    /**
     * Tab index per il campo CAUSE settare come active
     */
    $scope.activeCauseTab = 0;

    function resetSituationRecord(srType) {
      if (srType) {
        //inizializzo l'oggetto situation record
        $scope.curSituationRecord = situationRecordClass.reset();
        angular.forEach($scope.curSituationRecordTypeList, function (type) {
          if (type) {
            $scope.curSituationRecord = situationRecordClass.init(type.element);
            if (
              $scope.curSituationRecord &&
              $scope.curSituationRecord.validityPeriods &&
              !$scope.curSituationRecord.validityPeriods.length
            ) {
              $scope.newValidityPeriods = [];
              existingValidityPeriods = [];
              $scope.addNewValidityPeriod(); //genero un validation period
            }
          }
        });
      }
    }

    /**
     * Setta le variabili in base al tipo di SR selezionato
     * @param {type} srType
     * @return {undefined}
     */
    function selectSituationRecordType(srType) {
      if (srType) {
        //aggiorno il tipo selezionato
        if (!srType.children || srType.children.length === 0) {
          $scope.curSituationRecordType = srType;

          //$scope.menuStatus.isCollapsed = true;
        }
        //aggiorno il path di derivazione del tipo
        $scope.curSituationRecordTypeList = [];
        var node = srType;

        while (node && node.level !== undefined && node.level >= 0) {
          if (node) {
            $scope.curSituationRecordTypeList.push(node);
            node = clazzNodeFilter(node.parent.element, $scope.situationRecordTypesTree);
          }
        }
      }
    }
    $scope.isSituationRecordTypeSelected = function (srType) {
      var ret = false;
      if (srType) {
        angular.forEach($scope.curSituationRecordTypeList, function (type) {
          if (type) {
            if (srType === type.element) ret = true;
          }
        });
      }
      return ret;
    };

    /**
     * Inserimento situation record
     * @return {.$q@call;defer.promise}
     */
    function createSituationRecord() {
      var deferred = $q.defer();
      $scope.saveSituationRecordErrors = [];
      $scope.curSituationRecord.id = null; //se passo 0 il BE se lo prende!

      //aggiungo i nuovi validity periods
      if ($scope.newValidityPeriods) {
        if (!$scope.curSituationRecord.validityPeriods) {
          $scope.curSituationRecord.validityPeriods = [];
        }
        angular.forEach($scope.newValidityPeriods, function (vp) {
          $scope.curSituationRecord.validityPeriods.push(vp);
        });
      }

      situationRecordService.create(
        $scope.curSituationRecord,
        function (res) {
          var ret = res;
          delete ret.$promise;
          delete ret.$resolved;
          situationRecordClass.formatCurSituationRecordDates(ret);
          $scope.curSituationRecord = ret;

          var msg = translateFilter('AstralSituationRecord.saveSuccess');
          //toastService.createSuccessToast(msg);
          deferred.resolve(msg);
        },
        function (error) {
          //errorHandler(error);

          //ripristino la situazione originaria
          $scope.curSituationRecord.validityPeriods = null;
          if (existingValidityPeriods) {
            $scope.curSituationRecord.validityPeriods = [];
            angular.forEach(existingValidityPeriods, function (vp) {
              $scope.curSituationRecord.validityPeriods.push(vp);
            });
          }

          deferred.reject(error);
        }
      );
      return deferred.promise;
    }
    /**
     * Modifica situation record
     * @return {.$q@call;defer.promise}
     */
    function updateSituationRecord() {
      var deferred = $q.defer();

      //aggiungo i nuovi validity periods
      if ($scope.newValidityPeriods) {
        if (!$scope.curSituationRecord.validityPeriods) {
          $scope.curSituationRecord.validityPeriods = [];
        }
        angular.forEach($scope.newValidityPeriods, function (vp) {
          $scope.curSituationRecord.validityPeriods.push(vp);
        });
      }

      situationRecordService.update(
        $scope.curSituationRecord,
        function (res) {
          var ret = res;
          delete ret.$promise;
          delete ret.$resolved;
          situationRecordClass.formatCurSituationRecordDates(ret);
          $scope.curSituationRecord = ret;

          var msg = translateFilter('AstralSituationRecord.saveSuccess');
          //toastService.createSuccessToast(msg);

          deferred.resolve(msg);
        },
        function (error) {
          //errorHandler(error);
          //
          //ripristino la situazione originaria
          $scope.curSituationRecord.validityPeriods = null;
          if (existingValidityPeriods) {
            $scope.curSituationRecord.validityPeriods = [];
            angular.forEach(existingValidityPeriods, function (vp) {
              $scope.curSituationRecord.validityPeriods.push(vp);
            });
          }

          deferred.reject(error);
        }
      );
      return deferred.promise;
    }
    /**
     * Upload attachment
     * @param {type} indexes
     * @return {.$q@call;defer.promise}
     */
    function uploadSituationRecordAttachment(indexes) {
      var deferred = $q.defer();

      if (
        !indexes ||
        indexes.uplIdx === undefined ||
        !$scope.curAttachmentList ||
        $scope.curAttachmentList.length === 0 ||
        $scope.curAttachmentList.length < indexes.uplIdx
      ) {
        deferred.resolve();
        return deferred.promise;
      }

      var attachment = $scope.curAttachmentList[indexes.uplIdx];
      indexes.uplIdx = indexes.uplIdx + 1;

      if (!attachment.id && attachment.id !== null) {
        //eseguo l'upload solo per i nuovi attachment, per cui l'id NON è settato
        situationRecordService.uploadAttachment(
          { id: $scope.curSituationRecord.id },
          { file: attachment.file },
          function (ret) {
            delete ret.$promise;
            delete ret.$resolved;
            attachment = ret;

            deferred.resolve(indexes);
          },
          function (error) {
            var msg =
              translateFilter('AstralSituationRecord.newAttachmentError') +
              ' ' +
              attachment.originalFileName;

            toastService.createErrorToast(msg);
            deferred.resolve(indexes); //risolvo ugualmente in modo da far continuare con gli upload successivi
          }
        );
      } else {
        deferred.resolve(indexes);
      }

      return deferred.promise;
    }

    /**
     * Delete attachment
     * @param {type} indexes
     * @return {.$q@call;defer.promise}
     */
    function deleteSituationRecordAttachment(indexes) {
      var deferred = $q.defer();

      if (
        !indexes ||
        indexes.delIdx === undefined ||
        !$scope.deletedAttachmentList ||
        $scope.deletedAttachmentList.length === 0 ||
        $scope.deletedAttachmentList.length < indexes.delIdx
      ) {
        deferred.resolve();
        return deferred.promise;
      }

      var attachment = $scope.deletedAttachmentList[indexes.delIdx];
      indexes.delIdx = indexes.delIdx + 1;
      //deletedAttachmentList.splice(0, 1); //rimuovo dalla lista degli attachment da processare

      if (attachment.id && attachment.id !== null) {
        //eseguo la delete solo degli attachment esistenti, per cui l'id è settato
        var params = {
          id: $scope.curSituationRecord.id,
          attachmentId: attachment.id,
        };

        situationRecordService.deleteAttachment(
          params,
          function (res) {
            deferred.resolve(indexes); //passo la lista degli attachment da processare alle chiamate successive
          },
          function (error) {
            var msg =
              translateFilter('AstralSituationRecord.delAttachmentError') +
              ' ' +
              attachment.originalFileName;
            toastService.createErrorToast(msg);
            deferred.resolve(indexes); //risolvo ugualmente in modo da far continuare con le cancellazioni successive, passo la lista degli attachment da processare alle chiamate successive
          }
        );
      } else {
        deferred.resolve(indexes);
      }

      return deferred.promise;
    }

    $scope.downloadAttachment = function (attachment) {
      var params = {
        id: $scope.curSituationRecord.id,
        attachmentId: attachment.id,
      };
      situationRecordService.downloadAttachment(
        params,
        function (response) {
          base64DownloadFactory.download(
            'data:' + response.headers('Content-Type') + ';base64,' + response.data,
            fileNameFilter(attachment.originalFileName),
            fileExtensionFilter(attachment.originalFileName)
          );
        },
        function (error) {
          errorHandler(error);
        }
      );
    };

    /**
     * Elaborazione attachment al salvataggio
     * @return {undefined}
     */
    function processAttachments() {
      var chain = undefined;

      var indexes = {
        delIdx: 0,
        uplIdx: 0,
      };
      if ($scope.deletedAttachmentList && $scope.deletedAttachmentList !== null) {
        angular.forEach($scope.deletedAttachmentList, function () {
          if (!chain) {
            chain = deleteSituationRecordAttachment(indexes);
          } else {
            chain = chain.then(deleteSituationRecordAttachment);
          }
        });
      }

      if ($scope.curAttachmentList && $scope.curAttachmentList !== null) {
        angular.forEach($scope.curAttachmentList, function () {
          if (!chain) {
            chain = uploadSituationRecordAttachment(indexes);
          } else {
            chain = chain.then(uploadSituationRecordAttachment);
          }
        });
      }

      if (!chain) {
        //nessuna operazione da eseguire sugli allegati
        chain = $q.defer();
        chain.resolve();
        return chain.promise;
      }

      return chain;
    }

    //                /**
    //                 * Formattazione dei campi ZonedDateTime del Situation Record
    //                 * @return {undefined}
    //                 */
    //                function formatCurSituationRecordDates(situationRecord) {
    //                    if (situationRecord.createdDate)
    //                        situationRecord.createdDate = zonedDateTimeToDateFilter(situationRecord.createdDate);
    //                    if (situationRecord.updatedDate)
    //                        situationRecord.updatedDate = zonedDateTimeToDateFilter(situationRecord.updatedDate);
    //                    if (situationRecord.validityPeriods) {
    //                        angular.forEach(situationRecord.validityPeriods, function (period) {
    //                            if (period.dateStart)
    //                                period.dateStart = zonedDateTimeToDateFilter(period.dateStart);
    //                            if (period.dateEnd)
    //                                period.dateEnd = zonedDateTimeToDateFilter(period.dateEnd);
    //                            //console.log("testbar", period);
    //                        });
    //                    }
    //                    ;
    //                }

    function checkUserInput() {
      // location
      var marker = 0;
      var direction = 0;
      var shape = 0;

      if ($scope.markers && $scope.markers.length > 0) marker = 1;

      if ($scope.directions && $scope.directions.originLat && $scope.directions.destinationLat)
        direction = 1;

      if ($scope.shapes && $scope.shapes.length > 0) shape += $scope.shapes.length;

      if (marker + direction + shape > 1) {
        // TODO GESTIONE LOCATION POLYGON O ALTRO TIPO DI LOCATION: MODIFICARE LA STRINGA DELL'ERRORE RESTITUITO!
        errorHandler(
          undefined,
          undefined,
          translateFilter('AstralSituationRecord.error.multipleObjOnMap')
        );
        return false;
      } else {
        if (marker + direction + shape === 0) {
          errorHandler(
            undefined,
            undefined,
            translateFilter('AstralSituationRecord.error.noObjOnMap')
          );
          return false;
        }
      }

      return true;
    }

    function getLocationType() {
      var ret = '';

      if ($scope.markers && $scope.markers.length > 0) {
        ret = 'MULTIPOINT';
      } else if ($scope.shapes && $scope.shapes.length > 0) {
        ret = 'POLYGON';
      } else if ($scope.directions && !$scope.directions.isEmpty) {
        ret = 'LINESTRING';
      }

      return ret;
    }

    // da oggetti mappa a SituationRecord.location
    function getUserLocation() {
      var ret = {
        type: '',
        coordinates: [],
      };

      if ($scope.markers && $scope.markers.length > 0) {
        ret.type = 'MULTIPOINT';

        angular.forEach($scope.markers, function (m) {
          var point = [m.lon, m.lat];
          ret.coordinates.push(point);
        });
      } else if ($scope.shapes && $scope.shapes.length > 0) {
        ret.type = 'POLYGON';

        if ($scope.shapes[0].vertex) {
          if ($scope.shapes[0].shapeType.toUpperCase() === 'RECTANGLE') {
            var vx = $scope.shapes[0].vertex.toJSON();

            var ne = [vx.east, vx.north];
            var nw = [vx.west, vx.north];
            var sw = [vx.west, vx.south];
            var se = [vx.east, vx.south];

            ret.coordinates.push(ne);
            ret.coordinates.push(nw);
            ret.coordinates.push(sw);
            ret.coordinates.push(se);
            ret.coordinates.push(ne);
          } else if ($scope.shapes[0].shapeType.toUpperCase() === 'POLYGON') {
            if (
              $scope.shapes[0].vertex.b &&
              $scope.shapes[0].vertex.b[0] &&
              $scope.shapes[0].vertex.b[0].length > 0
            ) {
              angular.forEach($scope.shapes[0].vertex.b[0], function (point) {
                var vertex = {
                  lat: point.lat,
                  lon: point.lng,
                };

                ret.coordinates.push(vertex);
                ret.coordinates.push(ret.coordinates[0]);
              });
            }
          }
        }
      } else if ($scope.directions && !$scope.directions.isEmpty) {
        ret.type = 'LINESTRING';

        ret.coordinates = [];
        ret.coordinates.push([$scope.directions.originLng, $scope.directions.originLat]);
        if ($scope.directions.wayPoints) {
          angular.forEach($scope.directions.wayPoints, function (wp) {
            var p = [wp.lng, wp.lat];
            ret.coordinates.push(p);
          });
        }
        ret.coordinates.push([$scope.directions.destinationLng, $scope.directions.destinationLat]);
      }

      return ret;
    }

    /**
     * Salvataggio situation record
     * @return {undefined}
     */
    $scope.saveSituationRecord = function () {
      if (!checkUserInput()) {
        return;
      }

      var myLocation = getUserLocation();
      var locationType = getLocationType();

      $scope.validationErrors = [];

      //formatto le date
      situationRecordClass.formatCurSituationRecordDates($scope.curSituationRecord);

      $scope.curSituationRecord.location = myLocation;

      if (locationType === 'LINESTRING') {
        // dati OpenLR - default
        // TODO - necessita implementazione vera
        var openLrList = [];
        var openLrPoint = {
          openlrLowestFRCToNextLRPoint: 'FRC_O',
          openlrDistanceToNextLRPoint: 10,
        };
        openLrList.push(openLrPoint);
        var openLrLocationEntity = {
          firstDirectionOpenlrLocationReferencePoint: openLrList,
          oppDirectionOpenlrLocationReferencePoint: openLrList,
        };
        $scope.curSituationRecord.openLrLocation = openLrLocationEntity;
      }

      //assegno la causa
      if ($scope.causeMgmt.type === 'enum') {
        $scope.curSituationRecord.cause = $scope.causeMgmt.enumVal;
      }
      if ($scope.causeMgmt.type === 'eventId') {
        $scope.curSituationRecord.cause = $scope.causeMgmt.eventId;
      }

      if (!$scope.curSituationRecord.id) {
        //create
        createSituationRecord().then(
          function (msg) {
            processAttachments(
              $scope.curSituationRecord.id,
              $scope.curAttachmentList,
              $scope.deletedAttachmentList
            ).then(function () {
              toastService.createSuccessToast(msg);
              doBack();
            });
          },
          function (error) {
            errorHandler(error);
          }
        );
      } else {
        //update

        updateSituationRecord().then(
          function (msg) {
            processAttachments(
              $scope.curSituationRecord.id,
              $scope.curAttachmentList,
              $scope.deletedAttachmentList
            ).then(
              function () {
                toastService.createSuccessToast(msg);
                doBack();
              },
              function (error) {
                errorHandler(error);
              }
            );
          },
          function (error) {
            errorHandler(error);
          }
        );
      }
    };

    /**
     * Array Errori di Validazione
     */
    $scope.validationErrors = [];
    /**
     * Management errori di validaziione riscontrati al salvataggio
     * @return {undefined}
     */
    function errorHandler(error, successMessage, errorMessage) {
      $scope.validationErrors = undefined;
      errorHandlerService
        .handle(error, successMessage, errorMessage)
        .then(function (validationErrors) {
          $scope.validationErrors = validationErrors;
          if ($scope.validationErrors) {
            toastService.createErrorToast(
              translateFilter('AstralSituationRecord.validationErrors')
            );
          }
        });
      if (error && error.status && error.status === errorHandlerService.status500) {
        doBack();
      }
    }

    //                function getValidationErrorFieldName(listName, index, propertyName) {
    //                    var fieldName = listName;
    //                    if (index !== undefined)
    //                        fieldName = fieldName + index;
    //                    if (propertyName)
    //                        fieldName = fieldName + "_" + propertyName;
    //
    //                    return fieldName;
    //                }
    //                ;

    $scope.getValidationErrorPopoverIsOpen = function (listName, index, propertyName) {
      var fieldName = errorHandlerService.getValidationErrorFieldName(
        listName,
        index,
        propertyName
      );
      return $scope.validationErrors.hasOwnProperty(fieldName);
    };

    $scope.getValidationErrorPopoverIsOpenValidityPeriods = function () {
      var fieldName = 'validityPeriods';
      var ret = $scope.validationErrors.hasOwnProperty(fieldName);
      if (!ret) {
        var i = 1;

        angular.forEach($scope.curSituationRecord.validityPeriods, function (vp) {
          if (!ret) {
            fieldName = errorHandlerService.getValidationErrorFieldName(
              'validityPeriods',
              i,
              'dateStart'
            );
            ret = $scope.validationErrors.hasOwnProperty(fieldName);
          }
          if (!ret) {
            fieldName = errorHandlerService.getValidationErrorFieldName(
              'validityPeriods',
              i,
              'dateEnd'
            );
            ret = $scope.validationErrors.hasOwnProperty(fieldName);
          }
          i = i + 1;
        });
      }
      return ret;
    };

    /**
     * Parsa i valori in $scope.validationErrors per i campi di tipo lista
     * @param {type} listName
     * @param {type} index
     * @param {type} property
     * @return {undefined}P
     */
    $scope.getValidationErrorPopoverMessage = function (listName, index, propertyName) {
      var fieldName = errorHandlerService.getValidationErrorFieldName(
        listName,
        index,
        propertyName
      );
      var msg = $scope.validationErrors[fieldName];

      return msg;
    };

    $scope.getValidationErrorPopoverMessageValidityPeriods = function () {
      var msg = $scope.getValidationErrorPopoverMessage('validityPeriods');
      if (!msg) {
        var i = 1;
        angular.forEach($scope.curSituationRecord.validityPeriods, function (vp) {
          if (!msg) {
            msg = $scope.getValidationErrorPopoverMessage('validityPeriods', i, 'dateStart');
          }
          if (!msg) {
            msg = $scope.getValidationErrorPopoverMessage('validityPeriods', i, 'dateEnd');
          }
          i = i + 1;
        });
      }
      return msg;
    };

    /**
     * Caricamento tipi situation record
     * @return {.$q@call;defer.promise}
     */
    function getSituationRecordTypes() {
      var deferred = $q.defer();
      situationRecordService.situationRecordGetTypes(
        function (res) {
          $scope.situationRecordTypesTree = res.children;

          deferred.resolve();

          angular.forEach($scope.situationRecordTypesTree, function (item) {
            //item.collapsed=false;
            setSituationRecordTypesAttr(item);
          });
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function setSituationRecordTypesAttr(item) {
      item.collapsed = false;
      if (item.children.length) {
        angular.forEach(item.children, function (child) {
          setSituationRecordTypesAttr(child);
        });
      }
    }

    /**
     * Caricamento Enumerazioni Datex2
     * @return {deferred.promise}
     */
    function getDatex2Enums() {
      var deferred = $q.defer();
      datex2EnumsService.getDatex2Enums(
        function (res) {
          if (res) {
            $scope.datex2Enums = angular.fromJson(res);
          }
          $scope.severityList = [];

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    /**
     * Caricamento Situation Record Source
     * @return {deferred.promise}
     */
    function getSources() {
      var deferred = $q.defer();
      var params = {
        page: 0,
        size: 1000,
        sort: 'desc',
      };
      sourceService.getAll(
        params,
        function (res) {
          $scope.situationRecordSources = res.content;

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }

    /**
     * Risultato ricerca eventi
     */
    $scope.situationRecordSearchResults = [];
    /**
     * Ricerca eventi
     * @param {type} filter
     * @param {type} page
     * @param {type} size
     * @param {type} sort
     * @return {.$q@call;defer.promise}
     */
    function searchSituationRecord(filter, page, size, sort) {
      var deferred = $q.defer();

      $scope.situationRecordSearchResults = [];

      //verfica dei filtri impostati
      if (!filter) filter = {};

      filter.clazz = situationRecordClass.getSituationRecordTypes().situationRecordFilter;
      if (!filter.validityPeriodsDateStart)
        filter.validityPeriodsDateStart = new Date('2010-01-01').getTime();
      var d = new Date();
      d = d.setFullYear(d.getFullYear() + 1);
      if (!filter.validityPeriodsDateEnd) filter.validityPeriodsDateEnd = d;
      if (!filter.topLeft)
        filter.topLeft = {
          x: -180,
          y: 90,
          z: null,
        };
      if (!filter.bottomRight)
        filter.bottomRight = {
          x: 180,
          y: -90,
          z: null,
        };

      var params = {};
      if (page !== undefined) params.page = page;
      if (size !== undefined) params.size = size;
      if (sort !== undefined) params.sort = sort;

      situationRecordService.search(
        params,
        filter,
        function (res) {
          $scope.situationRecordSearchResults = res.content;
          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    $scope.getSituationRecordRes = undefined;
    function getSituationRecord(id, showToast) {
      var deferred = $q.defer();

      if (showToast === undefined) {
        showToast = true;
      }

      $scope.getSituationRecordRes = undefined;
      //verfica dei filtri impostati
      if (id) {
        situationRecordService.get(
          { id: id },
          function (res) {
            if (res.id) {
              var ret = res;
              delete ret.$promise;
              delete ret.$resolved;
              //correggo i campi data
              situationRecordClass.formatCurSituationRecordDates(ret);

              $scope.getSituationRecordRes = ret;

              deferred.resolve();
            } else {
              if (showToast) {
                toastService.createErrorToast(
                  translateFilter('AstralSituationRecord.noResultFound') + ': id ' + id
                );
              }

              deferred.reject();
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject(errors);
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );

        deferred.reject();
      }

      return deferred.promise;
    }

    function getAttachmentList(situationRecordId) {
      var deferred = $q.defer();

      $scope.curAttachmentList = [];
      //verfica dei filtri impostati
      if (situationRecordId) {
        situationRecordService.getAttachmentList(
          { id: situationRecordId },
          function (res) {
            if (res) {
              var ret = res;
              delete ret.$promise;
              delete ret.$resolved;

              $scope.curAttachmentList = ret;

              deferred.resolve();
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject(errors);
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );

        deferred.reject();
      }

      return deferred.promise;
    }
    //*********************************************************************
    //**************************GESTIONE ACCORDION MAPPA ******************
    //*********************************************************************
    $scope.locationMgmt = {
      collapse: false,
    };
    //*********************************************************************

    $scope.setType = function (type) {
      $scope.curSituationRecordType = type;

      var situationRecordCopy = angular.copy($scope.curSituationRecord);
      delete situationRecordCopy.clazz;

      selectSituationRecordType($scope.curSituationRecordType);
      resetSituationRecord($scope.curSituationRecordType);

      $scope.curSituationRecord = Object.assign({}, $scope.curSituationRecord, situationRecordCopy);

      if ($scope.curSituationRecord.region) {
        $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
          return region.longName === $scope.curSituationRecord.region.longName;
        });
      }

      if ($scope.curSituationRecord.province) {
        var regionAndProvince = findRegionAndProvinceByProvinceShortName(
          $scope.curSituationRecord.province.shortName,
          $scope.regionList,
          $scope.provinceList
        );

        if (regionAndProvince && regionAndProvince.length) {
          if (regionAndProvince[0]) {
            $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
              return region.longName === regionAndProvince[0].longName;
            });
          }

          if (regionAndProvince[1]) {
            $scope.curSituationRecord.province = regionAndProvince[1];
          }
        }
      }

      loadSituationRecord();

      //carico gli attachment
      if ($stateParams.id) {
        getAttachmentList($stateParams.id).then(function () {});
      }
      //faccio una copia dei validity periods del situation record
      if ($scope.curSituationRecord.validityPeriods) {
        existingValidityPeriods = [];
        angular.forEach($scope.curSituationRecord.validityPeriods, function (vp) {
          existingValidityPeriods.push(vp);
        });
      }

      $scope.menuStatus.isCollapsed = true;
    };

    //*********************************************************************
    //**************************GESTIONE TYPEAHEAD CAUSA ******************
    //*********************************************************************
    $scope.causeMgmt = {
      type: 'enum',
      eventId: undefined,
      enumVal: undefined,
    };
    $scope.isCauseAccordionCollapsed = true;
    $scope.thCauseSelected = undefined;

    $scope.thCauseSearch = function (comment) {
      var filter = { comment: comment };
      $scope.thCauseResults = [];
      return searchSituationRecord(filter, undefined, undefined, 'createdDate,DESC').then(
        function () {
          if ($scope.situationRecordSearchResults) {
            for (var j = 0; j < $scope.situationRecordSearchResults.length; j++) {
              if ($scope.situationRecordSearchResults[j]) {
                for (var i = 0; i < $scope.situationRecordSearchResults[j].comments.length; i++) {
                  var item = {
                    comment:
                      translateFilter('AstralSituationRecord.id') +
                      ': ' +
                      $scope.situationRecordSearchResults[j].id +
                      '-' +
                      $scope.situationRecordSearchResults[j].comments[i].comment,
                    id: $scope.situationRecordSearchResults[j].id,
                  };

                  $scope.thCauseResults.push(item);
                }
              }
            }
          }
          return $scope.thCauseResults;
        }
      );
    };
    $scope.thCauseOnSelect = function (item) {
      if (item) {
        //$scope.curSituationRecord.cause = item.id;
        $scope.causeMgmt = {
          type: 'eventId',
          eventId: item.id,
          enumVal: undefined,
        };
      }
    };
    //*********************************************************************

    $scope.back = function () {
      //verifico se l'utente ha apportato modifiche
      if ($scope.srMgmtForm.$dirty) {
        var dialogInst = $uibModal.open({
          template: require('../modal/modalQuest.html'),
          controller: 'modalQuestCtrl',
          size: 'md',
          resolve: {
            params: function () {
              return {
                headerMessage: translateFilter('AstralSituationRecord.attention'),
                bodyMessage: translateFilter('AstralSituationRecord.notSavedChanges'),
                showCancelButton: true,
                showNoButton: true,
                showYesButton: true,
                cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
                noButtonText: translateFilter('AstralSituationRecord.no'),
                yesButtonText: translateFilter('AstralSituationRecord.yes'),
              };
            },
          },
        });
        dialogInst.result.then(
          function () {
            $scope.saveSituationRecord();
          },
          function (dismissValue) {
            if (dismissValue === 'cancel') {
            }
            if (dismissValue === 'no') {
              doBack();
            }
          }
        );
      } else {
        doBack();
      }
    };

    function doBack() {
      var params = undefined;
      if ($stateParams.curSearchFilter) {
        if (!params) params = {};
        params.curSearchFilter = $stateParams.curSearchFilter;
      }
      if ($stateParams.curSearchTemplateFilter) {
        if (!params) params = {};
        params.curSearchTemplateFilter = $stateParams.curSearchTemplateFilter;
      }
      $rootScope.back(params);
    }

    // *********************************************************************************
    // ***************************** EVENTI MAPPA **************************************
    // *********************************************************************************
    $scope.mapShapes = function (shapes) {
      //console.log('PARENT $scope.mapShapes', shapes);
      $scope.shapes = shapes;
    };

    $scope.mapDirections = function (route, waypoint) {
      //console.log('PARENT $scope.mapDirections', route, waypoint);

      $scope.directions = {};

      if (route && route.latLngs && route.latLngs.b && route.latLngs.b[0] && route.latLngs.b[0].b) {
        var routePoint = route.latLngs.b[0].b;

        var lastIdx = routePoint.length - 1;
        if (lastIdx > 0) {
          var oLat = routePoint[0].lat();
          var oLng = routePoint[0].lng();
          var dLat = routePoint[lastIdx].lat();
          var dLng = routePoint[lastIdx].lng();

          var waiP = [];
          for (var i = 1; i <= lastIdx - 1; i++) {
            var point = {
              lat: routePoint[i].lat(),
              lng: routePoint[i].lng(),
            };
            waiP.push(point);
          }

          $scope.directions = {
            idevent: $scope.curSituationRecord.id,
            icon: clazzIconFilter($scope.curSituationRecord.clazz),
            showPanel: false,
            panelName: 'P2',
            travelMode: '',
            originLat: oLat,
            originLng: oLng,
            destinationLat: dLat,
            destinationLng: dLng,
            wayPoints: waiP,
          };
        }
      }
    };

    $scope.mapMarkers = function (markers) {
      //console.log('PARENT $scope.markers', markers);
      $scope.markers = markers;
    };

    $scope.mapMarkerOpenEvent = function (marker) {
      //console.log('PARENT $scope.mapMarkerOpenEvent', marker);
      // niente
    };

    $scope.mapBoundChangeEvent = function (mapbounds) {
      //console.log('PARENT $scope.mapBoundChangeEvent');
      // TODO: niente per ora (cambia l'area di ricerca)
    };

    // *********************** altre funzioni Mappa ************************************

    // da situationRecord.location a oggetti mappa
    function getMapLocation() {
      if (
        $scope.curSituationRecord &&
        $scope.curSituationRecord.location &&
        $scope.curSituationRecord.location.type &&
        $scope.curSituationRecord.location.coordinates &&
        $scope.curSituationRecord.location.coordinates.length > 0
      ) {
        switch ($scope.curSituationRecord.location.type) {
          case 'LINESTRING':
            var lastIdx = $scope.curSituationRecord.location.coordinates.length - 1;

            var oLat = $scope.curSituationRecord.location.coordinates[0][1];
            var oLng = $scope.curSituationRecord.location.coordinates[0][0];
            var dLat = $scope.curSituationRecord.location.coordinates[lastIdx][1];
            var dLng = $scope.curSituationRecord.location.coordinates[lastIdx][0];
            var wPoint = [];

            for (var i = 1; i < lastIdx; i++) {
              var location = {
                lat: $scope.curSituationRecord.location.coordinates[i][1],
                lng: $scope.curSituationRecord.location.coordinates[i][0],
              };
              wPoint.push(location);
            }

            $scope.directions = {
              idevent: $scope.curSituationRecord.id,
              icon: clazzIconFilter($scope.curSituationRecord.clazz),
              showPanel: false,
              panelName: 'P2',
              travelMode: '',
              originLat: oLat.toString(),
              originLng: oLng.toString(),
              destinationLat: dLat.toString(),
              destinationLng: dLng.toString(),
              wayPoints: wPoint,
            };

            $scope.myMap.centerLat = oLat;
            $scope.myMap.centerLng = oLng;
            $scope.myMap.zoom = 14;

            break;

          case 'MULTIPOINT':
          case 'POINT':
            // markers
            $scope.markers = [];
            var desc = '';
            if (
              $scope.curSituationRecord.comments &&
              $scope.curSituationRecord.comments.length > 0 &&
              $scope.curSituationRecord.comments[0].comment
            ) {
              desc = $scope.curSituationRecord.comments[0].comment;
            }

            angular.forEach($scope.curSituationRecord.location.coordinates, function (point) {
              var markerEvent = {
                idevent: $scope.curSituationRecord.id,
                lon: point[0],
                lat: point[1],
                //icon: clazzIconFilter($scope.curSituationRecord.clazz),
                icon: '',
                description: desc,
              };

              $scope.markers.push(markerEvent);
            });

            $scope.myMap.centerLat = $scope.markers[0].lat;
            $scope.myMap.centerLng = $scope.markers[0].lon;
            $scope.myMap.zoom = 15;

            break;

          case 'POLYGON':
            var pol = [];
            angular.forEach($scope.curSituationRecord.location.coordinates, function (point) {
              var vertex = {
                lat: point[1],
                lng: point[0],
              };
              pol.push(vertex);
            });

            $scope.shapes.push(pol);

            $scope.myMap.centerLat = $scope.curSituationRecord.location.coordinates[0][1];
            $scope.myMap.centerLng = $scope.curSituationRecord.location.coordinates[0][0];

            break;
        }

        //$scope.$apply();
      }
    }

    function setMapHeight() {
      var windowHeight = $(window).outerHeight();
      //console.log('windowOuterHeight', windowHeight);
      $scope.myMap.mapDivStyle.height = windowHeight / 2;
      $scope.myMap.mapStyle.height = windowHeight / 2;
    }
    //***************************************************************************
    //**************************    ALLEGATI    *********************************
    //***************************************************************************

    /**
     * File uploader
     */
    $scope.uploader = new FileUploader();

    /**
     * lista degli allegati da aggiungere e fare l'upload
     */
    $scope.curAttachmentList = [];
    /**
     * lista degli allegati da cancellare
     */
    $scope.deletedAttachmentList = [];

    /**
     * Quando il file viene selezionato lo aggiungo alla lista degli attachment da uploadare
     * @param {type} item
     * @return {undefined}
     */
    $scope.uploader.onAfterAddingFile = function (item) {
      if ($scope.uploader.queue && $scope.uploader.queue.length > 0) {
        var attachment = {
          id: undefined,
          originalFileName: $scope.uploader.queue[$scope.uploader.queue.length - 1]._file.name,
          file: $scope.uploader.queue[$scope.uploader.queue.length - 1]._file, //item.file //$scope.uploader.queue[$scope.uploader.queue.length - 1]._file
        };
        $scope.curAttachmentList.push(attachment);

        $scope.uploader.clearQueue();
      }
    };

    $scope.delAttachment = function (item) {
      var index = $scope.curAttachmentList.indexOf(item);

      if (index > -1) {
        $scope.curAttachmentList.splice(index, 1);
        $scope.deletedAttachmentList.push(item);
      } else {
        var msg = translateFilter('AstralSituationRecord.delAttachmentError');
        toastService.createErrorToast(msg);
      }
    };

    //**************************************************************************

    //***************************************************************************
    //**************************    ELIMINA    **********************************
    //***************************************************************************
    $scope.delete = function () {
      var id;
      var isTemplate = false;
      if ($scope.curSituationRecord.id) {
        id = $scope.curSituationRecord.id;
        isTemplate = false;
      } else {
        if ($scope.curTemplate.id) {
          id = $scope.curTemplate.id;
          isTemplate = false;
        }
      }

      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'sm',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage: translateFilter('AstralSituationRecord.deleteItemQuest') + ' Id:' + id,
              showCancelButton: true,
              showNoButton: false,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.ok'),
            };
          },
        },
      });
      dialogInst.result.then(
        function () {
          if (isTemplate) {
            delTemplate(id).then(function () {
              $scope.back();
            });
          } else {
            delSituationRecord(id).then(function () {
              $scope.back();
            });
          }
        },
        function () {}
      );
    };

    function delSituationRecord(id) {
      var deferred = $q.defer();
      if (id) {
        //verifico se ci sono situation records legati a questo (ome causa)
        var params = {
          page: 0,
          size: 1,
          sort: undefined,
        };
        var d1 = new Date();
        var filter = {
          clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter,
          validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0),
          validityPeriodsDateEnd: new Date(
            d1.getFullYear() + 10,
            d1.getMonth(),
            d1.getDate(),
            0,
            0,
            0
          ),
          topLeft: {
            x: -180,
            y: 90,
            z: null,
          },
          bottomRight: {
            x: 180,
            y: -90,
            z: null,
          },
          cause: id,
        };

        situationRecordService.search(
          params,
          filter,
          function (res) {
            if (res.totalElements) {
              //ci sono dei situation record legati al source che si cerca di cancellare --> ERRORE
              var error = {
                data: {
                  description: translateFilter(
                    'AstralSituationRecord.Error.situationRecordDelExistingSituationRecord'
                  ),
                },
              };

              deferred.reject(error);
            } else {
              //non ci sono dei situation record legati a quello che si cerca di cancellare --> ESEGUO CANCELLAZIONE
              situationRecordService.delete(
                { id: id },
                function (res) {
                  var msg = translateFilter('AstralSituationRecord.deleteSuccess');
                  toastService.createSuccessToast(msg);

                  deferred.resolve();
                },
                function (errors) {
                  errorHandler(errors);

                  deferred.reject();
                }
              );
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject();
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );

        deferred.reject();
      }

      return deferred.promise;
    }
    function delTemplate(id) {
      situationRecordTemplateService.delete(
        { id: id },
        function (res) {
          var msg = translateFilter('AstralSituationRecord.deleteSuccess');
          toastService.createSuccessToast(msg);
          //refresh della pagina
          $scope.search();
        },
        function (errors) {
          errorHandler(errors);
        }
      );
    }
    //**************************************************************************

    //***************************************************************************
    //**************************    TEMPLATE    *********************************
    //***************************************************************************

    $scope.saveAsTemplate = function () {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalInput.html'),
        controller: 'modalInputCtrl',
        size: 'md',
        resolve: {
          params: function () {
            var params = {
              headerMessage: translateFilter('AstralSituationRecord.templateName'),
              showCancelButton: true,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.ok'),
            };
            if ($scope.curTemplate) {
              //MODIFICA TEMPLATE
              params.inputText = $scope.curTemplate.name;
            }

            return params;
          },
        },
      });
      dialogInst.result.then(
        function (inputText) {
          if (inputText) {
            //SALVATAGGIO TEMPLATE
            var data = {
              situationRecord: $scope.curSituationRecord,
            };
            if ($scope.curTemplate) {
              data.template = $scope.curTemplate;
            } else {
              data.template = {};
            }
            data.template.name = inputText;

            //assegno la location
            if (!checkUserInput()) {
              return;
            }

            $scope.curSituationRecord.location = getUserLocation();

            //formatto le date
            situationRecordClass.formatCurSituationRecordDates($scope.curSituationRecord);

            //assegno la causa
            if ($scope.causeMgmt.type === 'enum') {
              $scope.curSituationRecord.cause = $scope.causeMgmt.enumVal;
            }
            if ($scope.causeMgmt.type === 'eventId') {
              $scope.curSituationRecord.cause = $scope.causeMgmt.eventId;
            }

            if ($scope.curTemplate) {
              //MODIFICA TEMPLATE
              situationRecordTemplateService.update(
                data,
                function () {
                  var msg = translateFilter('AstralSituationRecord.saveSuccess');
                  toastService.createSuccessToast(msg);
                  doBack();
                },
                function (error) {
                  errorHandler(error);
                }
              );
            } else {
              //NUOVO TEMPLATE
              situationRecordTemplateService.create(
                data,
                function () {
                  var msg = translateFilter('AstralSituationRecord.saveSuccess');
                  toastService.createSuccessToast(msg);
                  doBack();
                },
                function (error) {
                  errorHandler(error);
                }
              );
            }
          } else {
            var msg = translateFilter('AstralSituationRecord.notValidTemplateName');
            toastService.createErrorToast(msg);
          }
        },
        function () {}
      );
    };

    //**************************************************************************
    function loadSituationRecord() {
      $scope.curSituationRecordType = clazzNodeFilter(
        $scope.curSituationRecord.clazz,
        $scope.situationRecordTypesTree
      );
      selectSituationRecordType($scope.curSituationRecordType);

      // campi position mappa
      getMapLocation();

      if ($scope.curSituationRecord.clazz) {
        //$scope.curSituationRecordType = findSituationRecordType($scope.curSituationRecord.clazz, $scope.situationRecordTypesTree);
        $scope.curSituationRecordType = clazzNodeFilter(
          $scope.curSituationRecord.clazz,
          $scope.situationRecordTypesTree
        );
      }

      if ($scope.curSituationRecord && $scope.curSituationRecord.cause) {
        if (
          datex2EnumsTranscodeFilter($scope.curSituationRecord.cause, $scope.datex2Enums.causeType)
        ) {
          $scope.causeMgmt = {
            type: 'enum',
            eventId: undefined,
            enumVal: $scope.curSituationRecord.cause,
          };
        } else {
          $scope.causeMgmt = {
            type: 'eventId',
            eventId: $scope.curSituationRecord.cause,
            enumVal: undefined,
          };
        }
      }
    }

    function getSituationRecordTemplateDetail(id, showToast) {
      var deferred = $q.defer();

      if (showToast === undefined) {
        showToast = true;
      }

      $scope.getSituationRecordRes = undefined;
      //verfica dei filtri impostati
      if (id) {
        situationRecordTemplateService.getDetail(
          { id: id },
          function (res) {
            if (res.id) {
              var ret = res;
              delete ret.$promise;
              delete ret.$resolved;
              //correggo i campi data
              situationRecordClass.formatCurSituationRecordDates(ret);

              $scope.getSituationRecordRes = ret;

              deferred.resolve();
            } else {
              if (showToast) {
                toastService.createErrorToast(
                  translateFilter('AstralSituationRecord.noResultFound') + ': id ' + id
                );
              }

              deferred.reject();
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject(errors);
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );

        deferred.reject();
      }

      return deferred.promise;
    }

    function findRegionAndProvinceByProvinceShortName(shortName, regionList, provinceList) {
      for (var i = 0; i < provinceList.length; i++) {
        var region = provinceList[i];

        for (var j = 0; j < region.provinces.length; j++) {
          var province = region.provinces[j];

          if (province.shortName === shortName) {
            return [
              regionList.find(function (r) {
                return r.longName === region.name;
              }),
              province,
            ];
          }
        }
      }

      return null;
    }

    function init() {
      $scope.pageHeader1 = undefined;
      $scope.pageHeader2 = undefined;

      $scope.curSituationRecordId = undefined;
      $scope.curAttachmentList = [];
      $scope.deletedAttachmentList = [];
      $scope.curTemplate = undefined;

      getSituationRecordTypes().then(function () {
        getDatex2Enums().then(function () {
          getSources().then(function () {
            if ($stateParams.id) {
              //MODIFICA SITUATION RECORD - IL PARAMETRO $stateParams.id ARRIVA DALLA RICERCA
              $scope.curSituationRecordId = $stateParams.id;
            }

            //NUOVO SITUATION RECORD
            if ($stateParams.situationRecordType) {
              //NUOVO SITUATION RECORD DA DASHBOARD
              $scope.curSituationRecordType = $stateParams.situationRecordType;
              selectSituationRecordType($scope.curSituationRecordType);
              resetSituationRecord($scope.curSituationRecordType);
            }
            //MODIFICA SITUATION RECORD
            if ($scope.curSituationRecordId) {
              $scope.pageHeader1 = translateFilter('AstralSituationRecord.eventMgmt');
              getSituationRecord($stateParams.id).then(function () {
                $scope.curSituationRecord = $scope.getSituationRecordRes;

                if ($scope.curSituationRecord.region) {
                  $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
                    return region.longName === $scope.curSituationRecord.region.longName;
                  });
                }

                if ($scope.curSituationRecord.province) {
                  var regionAndProvince = findRegionAndProvinceByProvinceShortName(
                    $scope.curSituationRecord.province.shortName,
                    $scope.regionList,
                    $scope.provinceList
                  );

                  if (regionAndProvince && regionAndProvince.length) {
                    if (regionAndProvince[0]) {
                      $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
                        return region.longName === regionAndProvince[0].longName;
                      });
                    }

                    if (regionAndProvince[1]) {
                      $scope.curSituationRecord.province = regionAndProvince[1];
                    }
                  }
                }

                loadSituationRecord();
                //carico gli attachment
                getAttachmentList($stateParams.id).then(function () {});
                //faccio una copia dei validity periods del situation record
                if ($scope.curSituationRecord.validityPeriods) {
                  existingValidityPeriods = [];
                  angular.forEach($scope.curSituationRecord.validityPeriods, function (vp) {
                    existingValidityPeriods.push(vp);
                  });
                }
              });
            } else {
              //NUOVO SITUATION RECORD
              $scope.pageHeader1 = translateFilter('AstralSituationRecord.newEvent');

              if ($stateParams.clonedSituationRecord) {
                $scope.pageHeader1 = translateFilter('AstralSituationRecord.duplicateEvent');
                $scope.curSituationRecord = $stateParams.clonedSituationRecord;
                $scope.curSituationRecord.comments[1].comment =
                  $scope.curSituationRecord.comments[1].comment + ' (Copia)';

                if ($scope.curSituationRecord.region) {
                  $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
                    return region.longName === $scope.curSituationRecord.region.longName;
                  });
                }

                if ($scope.curSituationRecord.province) {
                  var regionAndProvince = findRegionAndProvinceByProvinceShortName(
                    $scope.curSituationRecord.province.shortName,
                    $scope.regionList,
                    $scope.provinceList
                  );

                  if (regionAndProvince && regionAndProvince.length) {
                    if (regionAndProvince[0]) {
                      $scope.curSituationRecord.region = $scope.regionList.find(function (region) {
                        return region.longName === regionAndProvince[0].longName;
                      });
                    }

                    if (regionAndProvince[1]) {
                      $scope.curSituationRecord.province = regionAndProvince[1];
                    }
                  }
                }

                if ($scope.curSituationRecord.validityPeriods) {
                  angular.forEach($scope.curSituationRecord.validityPeriods, function (period) {
                    if (period.dateStart) {
                      period.dateStart = zonedDateTimeToDateFilter(period.dateStart);
                    }

                    if (period.dateEnd) {
                      period.dateEnd = zonedDateTimeToDateFilter(period.dateEnd);
                    }
                  });

                  $scope.newValidityPeriods = $scope.curSituationRecord.validityPeriods;
                  delete $scope.curSituationRecord.validityPeriods;
                }

                loadSituationRecord();
                if ($scope.curSituationRecord.validityPeriods) {
                  existingValidityPeriods = [];
                  angular.forEach($scope.curSituationRecord.validityPeriods, function (vp) {
                    existingValidityPeriods.push(vp);
                  });
                }
              }
            }

            //NUOVO SITUATION RECORD DA TEMPLATE
            if ($stateParams.situationRecordFromTemplate) {
              $scope.curSituationRecord = $stateParams.situationRecordFromTemplate;
              loadSituationRecord();
            }

            //MODIFICA TEMPLATE
            if ($stateParams.template) {
              $scope.curTemplate = $stateParams.template;
              $scope.pageHeader1 = translateFilter('AstralSituationRecord.templateMgmt');
              $scope.pageHeader2 = $scope.curTemplate.name;

              getSituationRecordTemplateDetail($scope.curTemplate.id).then(function () {
                $scope.curSituationRecord = $scope.getSituationRecordRes;
                loadSituationRecord();
                //annullo l'id del situation record
                $scope.curSituationRecord.id = undefined;
              });
            }
          });
        });
      });

      setMapHeight();
    }

    init();

    //                $scope.test=function(){
    //                    alert("test!");
    //                };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/situationRecord/situationRecordMgmtCtrl.js
// module id = 238
// module chunks = 0